
import { defineComponent, onBeforeMount, ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { domainStore } from '@/store/domain-store';
import { timelineStore } from '@/store/timeline-store';
import TimelineEntry from '@/components/timeline/displayElements/TimelineEntry.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
export default defineComponent({
  name: 'Timeline',
  components: {
    TimelineEntry,
    WdwDynbox,
  },
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    timelineid: {
      type: Number,
      required: true,
    },
    hidetitle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const min = ref(0);
    const max = ref(4);
    const entryAmount = ref(4);
    const windowsize = ref(window.innerWidth);
    const elementsWidth = ref({ width: '25%' });
    const fullScreen = ref(false);
    const initialized = ref(false);
    const moveDirection = ref('left');
    function setMinMax() {
      if (timelineStore.getState().closestIndex > 0 && !initialized.value) {
        if (timelineStore.getState().entries.length <= entryAmount.value) {
          min.value = 0;
        } else if (
          // closest index too far towards end
          timelineStore.getState().entries.length - entryAmount.value <= timelineStore.getState().closestIndex ||
          timelineStore.getState().closestIndex + entryAmount.value > timelineStore.getState().entries.length
        ) {
          min.value = timelineStore.getState().entries.length - entryAmount.value;
        } else {
          min.value = timelineStore.getState().closestIndex;
        }
      } else {
        min.value =
          timelineStore.getState().entries.length >= entryAmount.value
            ? timelineStore.getState().entries.length - entryAmount.value
            : 0;
      }
      max.value = min.value + entryAmount.value;
    }
    const timelineEntries = computed(() => {
      return [...timelineStore.getState().entries].reverse();
    });
    const timeline = computed(() => {
      return timelineStore.getState().timeline;
    });
    const loading = computed(() => {
      return timelineStore.getState().isLoadingContent;
    });
    const pager = computed(() => {
      return timelineStore.getState().pager;
    });
    const showRight = computed(() => {
      return max.value == timelineEntries.value.length ? true : false;
    });
    function canFetchAdditional() {
      return pager.value.total_entries > pager.value.entries_per_page * pager.value.current_page;
    }
    const showleft = computed(() => {
      if (min.value <= 0) {
        if (canFetchAdditional()) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    });
    function fetchLeft() {
      if (min.value == 0 && canFetchAdditional()) {
        timelineStore.fetchAddetionalEntries();
      } else {
        min.value -= 1;
        max.value -= 1;
      }
      moveDirection.value = 'left';
    }
    function fetchRight() {
      min.value += 1;
      max.value += 1;
      moveDirection.value = 'right';
    }
    function resizeBrowserHandler() {
      if (window.innerWidth > 700) {
        //default - 4 elements
        elementsWidth.value = { width: '25%' };
        entryAmount.value = 4;
        fullScreen.value = false;
      } else if (window.innerWidth <= 700 && window.innerWidth > 500) {
        // 3 elements
        elementsWidth.value = { width: '33%' };
        entryAmount.value = 3;
        fullScreen.value = true;
      } else if (window.innerWidth <= 500 && window.innerWidth > 300) {
        // 2 elements
        elementsWidth.value = { width: '50%' };
        entryAmount.value = 2;
        fullScreen.value = true;
      } else {
        // single element when super small
        elementsWidth.value = { width: '100%' };
        entryAmount.value = 1;
        fullScreen.value = true;
      }
    }
    onBeforeMount(() => {
      // set props to store for initialization
      domainStore.setDomainId(props.domainid);
      timelineStore.setTimelineid(props.timelineid);
      window.addEventListener('resize', resizeBrowserHandler);
    });
    onMounted(() => {
      resizeBrowserHandler();
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeBrowserHandler);
    });
    watch(timelineEntries, (newvalue, oldvalue) => {
      if (newvalue && !initialized.value) {
        setMinMax();
        initialized.value = true;
      }
    });
    watch(loading, (newvalue, oldvalue) => {
      if (newvalue == false) {
        setMinMax();
        min.value -= 1;
        max.value -= 1;
      }
    });
    return {
      timeline,
      timelineEntries,
      windowsize,
      showRight,
      showleft,
      max,
      min,
      elementsWidth,
      fullScreen,
      fetchRight,
      fetchLeft,
      canFetchAdditional,
      moveDirection,
    };
  },
});
